import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import FaceIcon from '@material-ui/icons/FaceOutlined';

import classes from '../../css/getCSS';

const lifestyleInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('lifestyleinfo')}>Edit</Button>
    );
  }
  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <FaceIcon className={classes.titleIcon} />
          Lifestyle
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Body Type</p>
            <p className={classes.profileVal}>
              {props.profile.lifestyleinfo.body_type
                ? props.profile.lifestyleinfo.body_type.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Diet</p>
            <p className={classes.profileVal}>
              {props.profile.lifestyleinfo.diet
                ? props.profile.lifestyleinfo.diet.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Smoke</p>
            <p className={classes.profileVal}>
              {props.profile.lifestyleinfo.smoke
                ? props.profile.lifestyleinfo.smoke.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Drink</p>
            <p className={classes.profileVal}>
              {props.profile.lifestyleinfo.drink
                ? props.profile.lifestyleinfo.drink.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>Physical Disabilities</p>
            <p className={classes.profileVal}>
              {props.profile.lifestyleinfo.physical_disabilities ? props.profile.lifestyleinfo.physical_disabilities : 'None'}
            </p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default lifestyleInfo;



// WEBPACK FOOTER //
// ./src/profile/components/LifestyleInfo.js